export default "__VITE_ASSET__UN6O6ocS__"